
		<go-suite-loader *ngIf="loading"></go-suite-loader>
		<div class="window-background"></div>
	


// WEBPACK FOOTER //
// ./src/app/shared/components/router-loader/router-loader.component.ts.RouterLoaderComponent.html